import { Injectable } from '@angular/core';
import { SharedService } from '../../shared/service/shared.service';
import { environment } from '../../../../environments/environment';

@Injectable()
export class SignupService {
	// Define valiables
	SITE_API_URL: any = '';
	data: any = {};

	// Define constructor
	constructor(public sharedService: SharedService) {
		this.SITE_API_URL = environment.API_URL;
	}

    /**this function is used submit signup form */
	submitUserSignupDetail = (formData : any ): any => {
        const methodName  				    = 'user_registration';
		const methodUrl 				    = environment.API_URL + methodName;
        this.data                           = {};
        this.data.data                      = formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}

    /**this function is used submit signup form */
	submitUserSignupDetails = (formData : any ): any => {
        const methodName  				    = 'user_registration';
		const methodUrl 				    = environment.API_URL + methodName;
		return this.sharedService.getPostImage(methodUrl, formData);
	}

	/**this function is used submit signup form */
	submitOtp = (formData : any ): any => {
        const methodName  				    = 'verify_otp';
		const methodUrl 				    = environment.API_URL + methodName;
        this.data                           = {};
        this.data.data                      = formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}

	/**this function is used to resend otp */
	resendOtp = (formData : any ): any => {
		const methodName  				    = 'resend_otp';
		const methodUrl 				    = environment.API_URL + methodName;
		this.data                           = {};
		this.data.data                      = formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}

	/**this function is used for login */
	login = (formData : any ): any => {
		const methodName  				    = 'login';
		const methodUrl 				    = environment.API_URL + methodName;
		this.data                           = {};
		this.data.data                      = formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}

	/**this function is used for forgot password */
	forgotPassword = (formData : any ): any => {
		const methodName  				    = 'forgot_password';
		const methodUrl 				    = environment.API_URL + methodName;
		this.data                           = {};
		this.data.data                      = formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}

	/**this function is used to reset password */
	resetPassword = (formData : any ): any => {
		const methodName  				    = 'reset_password';
		const methodUrl 				    = environment.API_URL + methodName;
		this.data                           = {};
		this.data.data                      = formData;	
		return this.sharedService.getPost(methodUrl, this.data);
	}

	/**this function is used to change password */
	changePassword = (formData : any ): any => {
		const methodName  				    = 'change_password';
		const methodUrl 				    = environment.API_URL + methodName;
		this.data                           = {};
		this.data.data                      = formData;	
		return this.sharedService.getPost(methodUrl, this.data);
	}

	/**this function is used submit email otp */
	submitEmailOtp = (formData : any ): any => {
        const methodName  				    = 'verify_email_otp';
		const methodUrl 				    = environment.API_URL + methodName;
        this.data                           = {};
        this.data.data                      = formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}

	/**this function is used to verify email */
	resendEmailOtp = (formData : any ): any => {
		const methodName  				    = 'verify_email';
		const methodUrl 				    = environment.API_URL + methodName;
		this.data                           = {};
		this.data.data                      = formData;
		return this.sharedService.getPost(methodUrl, this.data);
	}

	/** This function is used to add user wishlist.  */
	saveWishlistJobs = (formData : any): any => {
		const methodName					=	'add_user_wishlist';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data); 
	}
	
	/** This function is used to get applied jobs  */
	appliedJob = (formData : any): any => {
		const methodName					=	'job_apply';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data); 
	}
	
	/** This function is used to get wishlist saved jobs  */
	getWishlistJobs = (formData : any): any => {
		const methodName					=	'get_wishlist_saved_jobs';
		const methodUrl						=	environment.API_URL + methodName;
		this.data							=	{};
		this.data.data						=	formData;
		return this.sharedService.getPost(methodUrl, this.data); 
	}
}
